import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import TOCHForceSignInComponent from './js/toch-force-sign-in/toch-force-sign-in.component';
import MasterCardRegistrationComponent from './js/mastercard-registration/mastercard-registration.component';
import CountdownAlertBarComponent from './js/countdown-alertbar/countdown-alertbar.component';

ComponentsFactory.getInstance().define('toch-force-sign-in', TOCHForceSignInComponent);
ComponentsFactory.getInstance().define('mastercard-registration', MasterCardRegistrationComponent);
ComponentsFactory.getInstance().define('countdown-alertbar', CountdownAlertBarComponent);
